module.exports = __webpack_public_path__ + "static/img/code-icon2.a5ce7ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/popup/code-icon2.png
// module id = RdRw
// module chunks = 1